import React from 'react';
import { useReveal } from '../lib/useReveal';
const MORE_TESTIMONIALS = [{
  initials: 'CR',
  name: 'Cecilia R.',
  province: 'Mendoza',
  stars: 5,
  text: 'El Tomo IV — Protocolos de Sesión — me salvó. Mi primera sesión oficial fue perfecta. El cliente lloró. Yo también. Nunca pensé que iba a poder hacer esto.'
}, {
  initials: 'SC',
  name: 'Sofía C.',
  province: 'La Plata',
  stars: 5,
  text: 'El Tomo VI de Consultorio Profesional me dio todo lo que necesitaba para cobrar lo que vale mi trabajo sin bajar la voz. Ahora tengo mis precios claros.'
}, {
  initials: 'PA',
  name: 'Paula A.',
  province: 'Neuquén',
  stars: 5,
  text: 'El Bono 5 — Plan de 14 Días — fue lo que me mantuvo constante el primer mes. Sin esa estructura creo que hubiera abandonado como siempre.'
}, {
  initials: 'JM',
  name: 'Julia M.',
  province: 'Rosario',
  stars: 5,
  text: 'El Tomo V con los casos clínicos reales me dio la confianza que me faltaba. Ahora trabajo con clientes en situaciones difíciles y sé exactamente qué hacer.'
}];
function StarRating({
  count
}: {
  count: number;
}) {
  return <div className="flex gap-0.5" data-id="element-203">
      {Array.from({
      length: count
    }).map((_, i) => <span key={i} className="text-[#eab308] text-sm" data-id="element-204">
          ⭐
        </span>)}
    </div>;
}
function TestimonialCard({
  initials,
  name,
  province,
  stars,
  text,
  index
}: {
  initials: string;
  name: string;
  province: string;
  stars: number;
  text: string;
  index: number;
}) {
  const [ref, vis] = useReveal();
  return <div ref={ref} className={`reveal bg-[#111111] border border-white/10 rounded-xl p-5 sm:p-6 flex flex-col gap-3 transition-all duration-500 hover:border-[#eab308]/30 hover:shadow-[0_0_20px_rgba(234,179,8,0.08)] ${vis ? 'is-visible' : ''}`} style={{
    transitionDelay: `${index * 100}ms`
  }} data-id="element-205">
      <div className="flex items-center justify-between mb-1" data-id="element-206">
        <div className="flex items-center gap-2" data-id="element-207">
          <div className="w-8 h-8 rounded-full bg-[#eab308]/15 border border-[#eab308]/25 flex items-center justify-center flex-shrink-0" data-id="element-208">
            <span className="text-[#eab308] font-bold text-xs" data-id="element-209">{initials}</span>
          </div>
          <StarRating count={stars} data-id="element-210" />
        </div>
      </div>
      <p className="text-gray-300 text-sm sm:text-base leading-relaxed flex-grow italic" data-id="element-211">
        "{text}"
      </p>
      <div className="pt-2 border-t border-white/5" data-id="element-212">
        <p className="text-white text-sm font-semibold" data-id="element-213">
          {name} — {province}
        </p>
      </div>
    </div>;
}
export function MoreTestimonialsSection() {
  const [ref, vis] = useReveal();
  return <section className="bg-[#0a0a0a] py-12 md:py-16 px-4 sm:px-6 border-t border-white/5" data-id="element-214">
      <div className="container mx-auto max-w-5xl" data-id="element-215">
        <div ref={ref} className={`reveal text-center mb-10 ${vis ? 'is-visible' : ''}`} data-id="element-216">
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-white tracking-wide" data-id="element-217">
            ❤️ MÁS PERSONAS QUE YA LO TIENEN
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-218">
          {MORE_TESTIMONIALS.map((t, i) => <TestimonialCard key={i} {...t} index={i} data-id="element-219" />)}
        </div>
      </div>
    </section>;
}